// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d31e74e3","453":"7e284e61"}[chunkId] + ".chunk.js";
};